import React from 'react'
import PropTypes from 'prop-types'

import LinkButton from '../LinkButton'

import './index.scss'
import sideimage from 'assets/images/sideimage.svg'

function PageForbidden({ text, goBackText, canGoBack = true }) {
  return (
    <div className='ublique-page-forbidden'>
      <img alt='forbidden' src={sideimage} />
      <h1>{text}</h1>
      {canGoBack && (
        <LinkButton back className='ublique-page-forbidden--back-button'>
          {goBackText}
        </LinkButton>
      )}
    </div>
  )
}

PageForbidden.propTypes = {
  text: PropTypes.string.isRequired,
  goBackText: PropTypes.string.isRequired
}

export default PageForbidden
